import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';
import {
  isMobile
} from "react-device-detect";


export default class Additionalpopup extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
        open: false,
        cardType: "",
        nowPayCardType: "",
        user_name: "",
        user_number: "",
        user_address: "",
        user_lastnumber: "",
        prev_company: "",
        pay_company: "",
        card_number: "",
        card_month: "",
        card_year: "",
        pay_number: "",
        data: null,
        prev_agency: "S",
        relationship: "본인",
        is_minor: 0,
        callback_phone_number: "",
        user_request_number: ""
    }
    this.optionString = [
      "신규신청서",
      "기기변경신청서",
      "번호이동신청서"
    ];
  }
  Open(type, data)
  {
    this.appl_type = type;
    this.setState({
        open: true,
        data: data
    });
  }
  Close()
  {
    this.setState({
        open: false
    });
  }
  Apply()
  {
    //console.log(this.state.prev_company);
    this.submitData();
  }
  onCardChanged(event)
  {
    this.setState({
      cardType: event.target.value,
      prev_company: "",
      user_lastnumber: ""
    });
  }
  onPayCardChanged(event)
  {
    this.setState({
      nowPayCardType: event.target.value
    });
  }
  onUserNameChanged(event)
  {
    this.setState({
      user_name: event.target.value
    });
  }
  onUserNumberChanged(event)
  {
    this.setState({
      user_number: event.target.value
    });
  }
  onUserAddrChanged(event)
  {
    this.setState({
      user_address: event.target.value
    });
  }
  onUserLastnumberChanged(event)
  {
    this.setState({
      user_lastnumber: event.target.value
    });
  }
  onPrevCompanyChanged(event)
  {
      this.setState({
        prev_company: event.target.value
      })
  }
  onPayCompanyChanged(event)
  {
      this.setState({
        pay_company: event.target.value
      });
  }
  onCardNumberChanged(event)
  {
    this.setState({
      card_number: event.target.value
    });
  }
  onCardLastYearChanged(event)
  {
    this.setState({
      card_month: event.target.value,
      card_year: event.target.value
    });
  }
  onPayNumberChanged(event)
  {
    this.setState({
      pay_number: event.target.value
    });
  }
  onAgencyChanged(event)
  {
    this.setState({
      prev_agency: event.target.value
    });
  }
  onCallbackPhoneChanged(event)
  {
    this.setState({
      callback_phone_number: event.target.value
    });
  }
  onUserRequestNumberChanged(event)
  {
    this.setState({
      user_request_number: event.target.value
    });
  }
  submitData()
  {
    const self = this;
    let welfare_idx = 0;
    let support_zone = self.state.data.support_zone, discount_type = 0;
    if( support_zone == 2 )
    {
      discount_type = this.state.data.select_discount_month;
    }
    if(self.state.data.select_welfare_item)
    {
      welfare_idx = self.state.data.select_welfare_item.idx;
    }

    if( !self.checkValidData() )
    {
      return false;
    }

    let add_service =  self.state.data.select_add_item;
    let additional_service = [];
    if( add_service ) {
      for( let i = 0 ; i < add_service.length ; i++ )
      {
          additional_service.push(add_service[i].idx);
      }
    }
    /*
    select_together_product: "",
    select_together_line: "",
    select_together_price: [],
    select_together_discount_price: 0,
    */

    let combined_discount = [];

    if( this.state.data.select_together_product != "" && this.state.data.select_together_line != "" )
    {
      combined_discount.push(this.state.data.select_together_product);
      combined_discount.push(this.state.data.select_together_line);
      let last = [];
      for( let i = 0 ; i < this.state.data.select_together_price.length ;i++) {
        let price = this.state.data.select_together_price[i];
        let piece = [];
        if( price.obj )
        {
          piece[0] = price.obj.name;
        } else {
          piece[0] = "";
        }

        piece[1] = -1;
        piece[2] = -1;
        if( this.state.data.select_focus_line_index != -1 )
        {
          if( i == this.state.data.select_focus_line_index )
          {
            piece[1] = 1;
          } else {
            piece[1] = 0;
          }
        }
        if( this.state.data.select_year_index != -1 )
        {
            piece[2] = this.state.data.select_year_index;
        }
        last.push(piece);
      }
      combined_discount.push(last);
    }
    let _is_minor = 0;
    var radios = document.getElementsByName('is_minor');
    for (var i = 0, length = radios.length; i < length; i++)
    {
     if (radios[i].checked)
     {
       _is_minor = radios[i].value;
     }
    }

    $.post('https://api.tfamily.co.kr/api/mobile/submit', {
          uk: self.state.data._pass_uk,
          device_idx: self.state.data._device_idx,
          fee_idx: self.state.data.select_price_item.idx,
          support: self.state.data.select_point_discount.data,
          installment_month: self.state.data.divide_month,
          discount_type: discount_type,
          sign_type: self.state.data.OptionTypeChar[self.state.data.OptionType-1],
          welfare_idx: welfare_idx,
          contract_discount_month: self.state.data.divide_discount_month,
          usim_idx: self.state.data.usimOption.idx,
          insurance_idx : (self.state.data.select_insure_item) ? self.state.data.select_insure_item.idx : null,
          appl_name: self.state.user_name,
          appl_reg_number: self.state.user_number,
          appl_phone_number: self.state.user_request_number,
          address: self.state.user_address,
          card_number: self.state.card_number,
          card_month: self.state.card_month,
          card_year: self.state.card_year,
          prev_pay_type: self.state.nowPayCardType,
          prev_pay_num: self.state.user_lastnumber,
          pay_type: self.state.nowPayCardType,
          pay_number: ( self.state.nowPayCardType == "A" ) ? self.state.pay_number : self.state.card_number,
          pay_company: self.state.pay_company,
          pay_month: self.state.pay_month,
          appl_type: self.appl_type,
          color: self.state.data.colorname,
          additional_service: additional_service.join(),
          prev_agency: self.state.prev_agency,
          card_0_idx: (self.state.data.select_prediscount_card) ? self.state.data.select_prediscount_card.idx : 0,
          card_1_idx: (self.state.data.select_postdiscount_card) ? self.state.data.select_postdiscount_card.idx : 0,
          combined_discount: JSON.stringify(combined_discount),
          is_minor: self.state.is_minor,
          relationship: self.state.relationship,
          callback_phone_number: self.state.callback_phone_number,
          subsidy: self.state.data.subsidy_price
    }, function(data){

      let parsedData = JSON.parse(data);

      if( parsedData.data ) {
          sessionStorage.setItem("backurl", parsedData.data);
      } else {
        let loginKey = localStorage.getItem('loginKey');
        if(loginKey && loginKey != "")
        {
          sessionStorage.setItem("backurl", "http://tfamily.co.kr/Login?session=mobile");
        } else {
          sessionStorage.setItem("backurl", "http://www.tfamily.co.kr/");
        }
      }
      if( self.appl_type == 'T') {
        if( window.confirm("확인을 누르시면 상담 전화로 연결됩니다.")) {
            window.open('tel:15995168');
            window.location.href = '/OrderComplete';
        } else {
            window.location.href = '/OrderComplete';
        }
      } else if (self.appl_type == "C" ) {
          if( window.confirm("확인을 누르시면 카톡 상담 페이지가 열립니다.")) {
             window.open('http://pf.kakao.com/_xnZxcxej/chat');
             window.location.href = '/OrderComplete';
          } else {
             window.location.href = '/OrderComplete';
          }
      } else {
          window.location.href = '/OrderComplete';
      }
    });

  }
  checkValidData(){
    if( this.state.user_name == "" )
    {
      alert("사용자 성함을 입력해주세요.")
      return false;
    }
    if( this.state.user_number == "" )
    {
      alert("사용자 주민번호를 입력해주세요.")
      return false;
    }
    if( this.state.user_address == "" )
    {
      alert("받으실 곳 주소를 입력해주세요.")
      return false;
    }
    //console.log(this.state);
    // || this.state.pay_number == ""  || this.state.pay_company == ""
    if( this.state.nowPayCardType == "" )
    {
      alert("요금 납부 수단을 설정해주세요.")
      return false;
    }
    if( this.state.nowPayCardType == "C" && (this.state.card_number =="" || this.state.card_month == "") )
    {
      alert("요금 카드정보 및 유효기간 설정해주세요.")
      return false;
    }
    if( this.state.nowPayCardType == "A" && (this.state.pay_number == "" || this.state.pay_company == ""))
    {
        alert("요금 납부 계좌정보를 입력해주세요.")
        return false;
    }

    if( this.state.data.OptionType == 2 || this.state.data.OptionType == 3 )
    {
      /*
      cardType: event.target.value,
      prev_company: "",
      user_lastnumber: ""
      */
      if( this.state.cardType == "" || this.state.prev_company == "" || this.state.user_lastnumber == "")
      {
        //alert('기존 통신사 정보를 기입해주세요');
        //return false;
      }
    }
    return true;
  }
  changeRelationShip(item)
  {
    this.setState({
      relationship: $(item.target).text()
    });
  }
  changeBeforeAgency(val)
  {
    this.setState({
      prev_agency: val
    });
  }
  minorCheck(val)
  {
    this.setState({
      is_minor : val
    });
  }
  render()
  {
    /*
    <label><input type="checkbox" id="is_minor" name="is_minor" value="0"  />성인</label>&nbsp;&nbsp;
    <label><input type="checkbox" id="is_minor" name="is_minor" value="1"  />미성년</label>
    */
    let relationItem = ["본인","부모님","자녀","친척","배우자"];

    const self = this;
    return (
      <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
        <div className="modal-dialog modal-md mb0">
          <div className="popupPadding2">
            <div className="md-popup-header2 relative"> <img src={'/img/skt.jpeg'} className="logoAddMax"/> &nbsp;
            <span className="logoAddTxt">
            {(self.state.data)? self.optionString[self.state.data.OptionType-1] : null}
            </span>

              <div className="text-right floatright mt22">

                      <div class="pretty p-icon p-rotate">
                        <input type="checkbox" onClick={()=>{self.minorCheck(0)}} checked={ (self.state.is_minor == 0) ? 'checked':''}  />
                        <div class="state p-danger">
                          <i class="icon fa fa-check"></i>
                          <label>성인</label>
                        </div>
                        </div>
                        <div class="pretty p-icon p-rotate">
                          <input type="checkbox" onClick={()=>{self.minorCheck(1)}} checked={ (self.state.is_minor == 1) ? 'checked':''} />
                          <div class="state p-danger">
                            <i class="icon fa fa-check"></i>
                            <label>미성년자</label>
                          </div>
                        </div>

              </div>
            </div>
            <div className="md-popup-content">
              <form className="pl10 pr10">
              <div className="form-group pt25">
                <div className="row">
                  <div className="col-xs-12 col-md-4 pt6">
                    <label htmlFor="relationship pt6">개통자와의 관계</label>
                  </div>
                  <div className="col-xs-12 col-md-8">

                    <select id="relationship" className="form-control hide">
                      <option value="본인">본인</option>
                      <option value="부모님">부모님</option>
                      <option value="자녀">자녀</option>
                      <option value="친척">친척</option>
                      <option value="배우자">배우자</option>
                    </select>

                    <ul className="nav nav-pills nav-justified promise calendar">
                      {relationItem.map((item)=>{
                        return (<li key={item}  className={'cursorhand border-gray promise1 start fontnor14 ' + ((item===self.state.relationship) ? 'active' : null)}><a onClick={self.changeRelationShip.bind(this)}>{item}</a></li>)
                      })}

                    </ul>

                  </div>
                </div>
              </div>
                <div className="form-group pt10">
                  <div className="row">
                    <div className="col-xs-12 col-md-4 pt6">
                      <label htmlFor="user_name ">신청자이름</label>
                    </div>
                    <div className="col-xs-12 col-md-8">
                        <input type="text" id="user_name" onChange={self.onUserNameChanged.bind(this)} className="form-control" placeholder="개통자 명의 (신청인)" />
                    </div>
                  </div>
                </div>

                {(self.state.data && self.state.data.OptionType != 1) ?
                <div className="form-group">
                  <div className="row">
                    <div className="col-xs-12 col-md-4 pt6">
                      <label htmlFor="user_request_number">개통 전화번호</label>
                    </div>
                    <div className="col-xs-12 col-md-8">
                      <input type="text" id="user_request_number" onChange={self.onUserRequestNumberChanged.bind(this)} className="form-control" placeholder="개통 전화번호" />
                    </div>
                  </div>
                </div>
                : null }
                <div className="form-group">
                  <div className="row">
                    <div className="col-xs-12 col-md-4 pt6">
                      <label htmlFor="user_number">연락 가능 전화번호</label>
                    </div>
                    <div className="col-xs-12 col-md-8">
                      <input type="text" id="callback_phone_number"  onChange={self.onCallbackPhoneChanged.bind(this)} className="form-control" placeholder="연락 가능한 전화번호" />
                    </div>
                  </div>
                </div>
                <div className="form-group pt10">
                  <div className="row">
                    <div className="col-xs-12 col-md-4 pt6">
                      <label htmlFor="user_number">개통자 주민번호</label>
                    </div>
                    <div className="col-xs-12 col-md-8">
                      <input type="text" id="user_number" onChange={self.onUserNumberChanged.bind(this)} className="form-control" placeholder="개통자 주민번호" />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-xs-12 col-md-4 pt6">
                      <label htmlFor="user_address">택배수령 주소</label>
                    </div>
                    <div className="col-xs-12 col-md-8">
                      <input type="text" id="user_address" onChange={self.onUserAddrChanged.bind(this)} className="form-control" placeholder="택배 수령 주소" />
                    </div>
                  </div>
                </div>
                {(self.state.data && self.state.data.OptionType == 3) ?
                <div className="form-group">
                  <div className="row">
                    <div className="col-xs-12 col-md-4 pt6">
                      <label htmlFor="user_name">기존통신사</label>
                    </div>
                    <div className="col-xs-12 col-md-8">
                      <select className="form-control hide" onChange={self.onAgencyChanged.bind(this)}>
                        <option value="S">SK</option>

                        {(self.state.data.OptionType == 3) ? <option value="K">KT</option> : null}
                        {(self.state.data.OptionType == 3) ? <option value="L">LG</option> : null}
                        {(self.state.data.OptionType == 3) ? <option value="M">MVNO</option> : null}
                      </select>
                      <ul className="nav nav-pills nav-justified promise calendar">
                        <li className={'border-gray promise1 start fontnor14 ' + ((self.state.prev_agency == 'S') ? 'active' : null)} ><a className="cursorhand" onClick={()=>{self.changeBeforeAgency('S')}}>SK</a></li>
                        <li className={'border-gray promise1 start fontnor14 ' + ((self.state.prev_agency == 'K') ? 'active' : null)} ><a className="cursorhand" onClick={()=>{self.changeBeforeAgency('K')}}>KT</a></li>
                        <li className={'border-gray promise1 start fontnor14 ' + ((self.state.prev_agency == 'L') ? 'active' : null)} ><a className="cursorhand" onClick={()=>{self.changeBeforeAgency('L')}}>LG</a></li>
                        <li className={'border-gray promise1 start fontnor14 ' + ((self.state.prev_agency == 'M') ? 'active' : null)} ><a className="cursorhand" onClick={()=>{self.changeBeforeAgency('M')}}>MVNO</a></li>
                      </ul>
                    </div>
                  </div>
                </div>  : null }

                {(self.state.data && self.state.data.OptionType == 3) ?
                <div className="form-group hide">
                  <label htmlFor="user_name">기존 통신사 요금 납부</label>
                  <div className="row">
                    <div className="col-xs-4">
                      <select onChange={self.onCardChanged.bind(this)} className="form-control">
                        <option selected="selected" value="0">미선택</option>
                        <option value="C">카드</option>
                        <option value="A">계좌이체</option>
                      </select>
                    </div>
                    <div className="col-xs-4">
                    {(self.state.cardType == 'C') ?
                      <select onChange={self.onPrevCompanyChanged.bind(this)} className="form-control">
                        <option selected="selected" value="">미선택</option>
                        <option value="신한카드">신한카드</option>
                        <option value="현대카드">현대카드</option>
                        <option value="롯데카드">롯데카드</option>
                        <option value="KB국민카드">KB국민카드</option>
                        <option value="우리카드">우리카드</option>
                        <option value="하나카드">하나카드</option>
                        <option value="삼성카드">삼성카드</option>
                      </select>
                       : null}
                    {(self.state.cardType == 'A') ?
                      <select onChange={self.onPrevCompanyChanged.bind(this)} className="form-control">
                        <option selected="selected" value="">미선택</option>
                        <option value="국민은행">국민은행</option>
                        <option value="신한은행">신한은행</option>
                        <option value="하나은행">하나은행</option>
                        <option value="산업은행">산업은행</option>
                        <option value="케이뱅크">케이뱅크</option>
                        <option value="카카오뱅크">카카오뱅크</option>
                        <option value="기업은행">기업은행</option>
                        <option value="농협은행">농협은행</option>
                        <option value="씨티은행">씨티은행</option>
                        <option value="SC제일은행">SC제일은행</option>
                        <option value="대구은행">대구은행</option>
                        <option value="부산은행">부산은행</option>
                        <option value="경남은행">경남은행</option>
                      </select>
                       : null}
                    </div>
                    <div className="col-xs-4">
                      {(self.state.cardType == 'A' || self.state.cardType == 'C') ?
                      <div>
                        <input type="text" id="user_lastnumber" onChange={self.onUserLastnumberChanged.bind(this)} className="form-control" />
                        <small>신용카드 혹은 계좌번호 뒷 4자리</small>
                      </div> : null }
                    </div>
                  </div>
                </div>
                : null }

                <div className="form-group pt10">
                  <div className="row">
                  <div className="col-xs-12 col-md-4 pt6" >
                    <label htmlFor="user_name">요금납부정보</label>
                  </div>
                  <div className="col-xs-12 col-md-8">
                      <div className="row">
                        <div className="col-xs-6">
                          <select  onChange={self.onPayCardChanged.bind(this)}  className="form-control">
                            <option value="">미선택</option>
                            { (self.state.data && self.state.data.OptionType == 2) ? <option value="U">기존유지</option> : null}
                            <option value="C">카드</option>
                            <option value="A">계좌이체</option>
                          </select>
                        </div>
                        <div className="col-xs-6">
                        {(self.state.nowPayCardType == 'C') ?
                          <select onChange={self.onPayCompanyChanged.bind(this)} className="form-control">
                            <option selected="selected" value="">미선택</option>
                            <option value="신한카드">신한카드</option>
                            <option value="현대카드">현대카드</option>
                            <option value="롯데카드">롯데카드</option>
                            <option value="KB국민카드">KB국민카드</option>
                            <option value="우리카드">우리카드</option>
                            <option value="하나카드">하나카드</option>
                            <option value="삼성카드">삼성카드</option>
                          </select>
                           : null}
                        {(self.state.nowPayCardType == 'A') ?
                          <select onChange={self.onPayCompanyChanged.bind(this)} className="form-control">
                            <option selected="selected" value="">미선택</option>
                            <option value="국민은행">국민은행</option>
                            <option value="신한은행">신한은행</option>
                            <option value="하나은행">하나은행</option>
                            <option value="산업은행">산업은행</option>
                            <option value="케이뱅크">케이뱅크</option>
                            <option value="카카오뱅크">카카오뱅크</option>
                            <option value="기업은행">기업은행</option>
                            <option value="농협은행">농협은행</option>
                            <option value="씨티은행">씨티은행</option>
                            <option value="SC제일은행">SC제일은행</option>
                            <option value="대구은행">대구은행</option>
                            <option value="부산은행">부산은행</option>
                            <option value="경남은행">경남은행</option>
                          </select>
                           : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {(self.state.nowPayCardType == 'C') ?
                <div className="form-group">
                  <div className="row">
                    <div className="col-xs-8">
                      <label for="user_name">카드번호</label>
                      <input type="text" id="card_number" onChange={this.onCardNumberChanged.bind(this)} className="form-control" />
                    </div>
                    <div className="col-xs-4">
                    <label for="user_name">유효기간(년월)</label>
                    <input type="text" id="card_month"  onChange={this.onCardLastYearChanged.bind(this)} className="form-control" />
                    </div>
                  </div>
                </div>
                 : null}
                {(self.state.nowPayCardType == 'A') ?
                <div className="form-group">
                  <label for="user_name">계좌번호</label>
                  <input type="text" id="pay_number" onChange={self.onPayNumberChanged.bind(this)} className="form-control" />
                </div>
                 : null}
                <div className="row text-center pt10">
                  <a href="#applyCard" onClick={()=>{self.Apply()}} className={'btn btn-bar btn-select2 ' + ((isMobile) ? 'btn-xs' : 'btn-md' )  }><i class="fas fa-file-signature"></i> 신청</a>&nbsp;&nbsp;&nbsp;&nbsp;
                  <a href="#cancel" onClick={()=>{self.Close()}} className={'btn btn-cancel btn-select2 ' + ((isMobile) ? 'btn-xs' : 'btn-md' )  }><i class="fas fa-undo-alt"></i> 취소</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
